export enum OrderTypesEnum {
  'new' = 'new',
  'inProgress' = 'inProgress',
  'completed' = 'completed',
}
